module.exports = __webpack_public_path__ + "static/media/Acuvue_DEFINE_Small_Color_6507-02.48041a8c.png";